import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TransportService { 

    constructor(private http: HttpClient) { }

    gettransportService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_transport`);
    }    	    
}
